import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserInfo } from "../features/user/userSlice";
import Cookies from "js-cookie";
import { setIsSignedOut } from "../features/auth/authSlice";
import { useNavigate } from "react-router-dom";
export const Context = createContext();

const AppContext = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // const is_signin = useSelector((state) => state.auth.is_signin);
  // const user = useSelector((state) => state.user.userInfo);
  // const dispatch = useDispatch();
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (is_signin) {
  //     dispatch(getUserInfo());
  //   }
  // }, [is_signin, dispatch]);

  // useEffect(() => {
  //   // logout if user deleted or user info is empty object
  //   if (is_signin && (!user || Object.keys(user).length === 0)) {
  //     Cookies.remove("bapat_optics_security");
  //     dispatch(setIsSignedOut());
  //     navigate("/");
  //   }
  // }, [is_signin, user, dispatch, navigate]);

  return (
    <Context.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
